import { Controller } from "@hotwired/stimulus"

/**
 * IoT Date Range Link Controller
 *
 * Links the reports' From / To pickers (CONEK-8772): picking a From date makes
 * every day before it unselectable in To, and picking a To date does the same
 * for every day after it in From. The server renders the same bounds as the
 * pickers' `min` / `max` from the APPLIED range; this keeps them in step while
 * the user is still choosing, before the form is submitted.
 *
 * Best-effort: a typed date bypasses the calendar, so the authoritative rule is
 * server-side — a reversed range is refused with a message, never swapped.
 *
 * Each target is a Ui::DatePickerComponent wrapper (data-controller
 * "ui--date-picker"); its `change` event bubbles here with detail.dates.
 */
export default class extends Controller {
  static targets = ["from", "to"]

  fromChanged(event) {
    const picker = this.pickerFor(this.toTarget)
    if (picker) picker.minDate = event.detail?.dates?.[0] || null
  }

  toChanged(event) {
    const picker = this.pickerFor(this.fromTarget)
    if (picker) picker.maxDate = event.detail?.dates?.[0] || null
  }

  pickerFor(element) {
    const el = element.matches('[data-controller~="ui--date-picker"]')
      ? element
      : element.querySelector('[data-controller~="ui--date-picker"]')
    return el
      ? this.application.getControllerForElementAndIdentifier(
          el,
          "ui--date-picker",
        )
      : null
  }
}
